__turbopack_context__.v({
  "burger": "header-menu-module-scss-module__7jwCVa__burger",
  "burgerCloseButton": "header-menu-module-scss-module__7jwCVa__burgerCloseButton",
  "burgerContainer": "header-menu-module-scss-module__7jwCVa__burgerContainer",
  "burgerLine": "header-menu-module-scss-module__7jwCVa__burgerLine",
  "menu": "header-menu-module-scss-module__7jwCVa__menu",
  "menuApply": "header-menu-module-scss-module__7jwCVa__menuApply",
  "menuContent": "header-menu-module-scss-module__7jwCVa__menuContent",
  "menuFooter": "header-menu-module-scss-module__7jwCVa__menuFooter",
  "menuFooterLink": "header-menu-module-scss-module__7jwCVa__menuFooterLink",
  "menuHeaderGradient": "header-menu-module-scss-module__7jwCVa__menuHeaderGradient",
  "menuIcon": "header-menu-module-scss-module__7jwCVa__menuIcon",
  "navItem": "header-menu-module-scss-module__7jwCVa__navItem",
  "navLink": "header-menu-module-scss-module__7jwCVa__navLink",
  "navLinkActive": "header-menu-module-scss-module__7jwCVa__navLinkActive",
  "navLinkButton": "header-menu-module-scss-module__7jwCVa__navLinkButton",
  "navList": "header-menu-module-scss-module__7jwCVa__navList",
  "show": "header-menu-module-scss-module__7jwCVa__show",
  "subMenu": "header-menu-module-scss-module__7jwCVa__subMenu",
  "subMenuBackIcon": "header-menu-module-scss-module__7jwCVa__subMenuBackIcon",
  "subMenuCard": "header-menu-module-scss-module__7jwCVa__subMenuCard",
  "subMenuCardCtaIcon": "header-menu-module-scss-module__7jwCVa__subMenuCardCtaIcon",
  "subMenuCardDescription": "header-menu-module-scss-module__7jwCVa__subMenuCardDescription",
  "subMenuCardTitle": "header-menu-module-scss-module__7jwCVa__subMenuCardTitle",
  "subMenuContent": "header-menu-module-scss-module__7jwCVa__subMenuContent",
  "subMenuHeader": "header-menu-module-scss-module__7jwCVa__subMenuHeader",
  "subMenuHeaderGradient": "header-menu-module-scss-module__7jwCVa__subMenuHeaderGradient",
  "subMenuLink": "header-menu-module-scss-module__7jwCVa__subMenuLink",
  "subMenuList": "header-menu-module-scss-module__7jwCVa__subMenuList",
  "subMenuListItem": "header-menu-module-scss-module__7jwCVa__subMenuListItem",
  "subMenuOverlay": "header-menu-module-scss-module__7jwCVa__subMenuOverlay",
  "subMenuShow": "header-menu-module-scss-module__7jwCVa__subMenuShow",
});
